const alertTimeout = 3000;

export function flashInfo(message) {
  flash("info", message);
}

export function flashError(message) {
  flash("error", message);
}

export function flashSuccess(message) {
  flash("success", message);
}

export function flashWarning(message) {
  flash("warning", message);
}

export default function flash(type, message) {
  if (!message) return;

  // generate a random ID so we can find and remove it later automatically
  let random = Math.random().toString(16).substr(2);
  let randomId = `message-${random}`;

  $(".flashes").append(
    `<div id="${randomId}" class="alert alert-${type}" role="alert">${message}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>`
  );

  if (type === "info" || type === "success") {
    // Automatically close transient messages, keep warnings and errors until
    // closed.
    $(`#${randomId}`).delay(alertTimeout).fadeOut(500);
  }
}

// remove flash by clicking anywhere on it, not just the X in the corner
$(document).on("click", ".flashes .alert", (e) => e.target.remove());

// make sure the flash alerts are not cached
$(document).on("turbolinks:before-cache", function () {
  $(".flashes .alert").remove();
});

$(document).on("turbolinks:load", function () {
  $(".flashes .alert-notice").delay(alertTimeout).fadeOut(500);
  $(".flashes .alert-success").delay(alertTimeout).fadeOut(500);
});
